import Nav from "./landing/Nav";
import Hero from "./landing/Hero";
import Marquee from "./landing/Marquee";
import Bento from "./landing/Bento";
import RoiCalculator from "./landing/RoiCalculator";
import HowItWorks from "./landing/HowItWorks";
import Pricing from "./landing/Pricing";
import ModulesAccordion from "./landing/ModulesAccordion";
import Faq from "./landing/Faq";
import Cta from "./landing/Cta";
import Footer from "./landing/Footer";

export default function Landing() {
  return (
    <div className="bg-zinc-50 text-zinc-900 min-h-screen selection:bg-amber-500 selection:text-white">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Bento />
        <RoiCalculator />
        <HowItWorks />
        <Pricing />
        <ModulesAccordion />
        <Faq />
        <Cta />
      </main>
      <Footer />
    </div>
  );
}
